$(document).ready(function () {
    const $swiperContainer = $(".included-accessories__carousel");
    if ($swiperContainer.length === 0) return; 

    const swiper = new Swiper($swiperContainer[0], { 
        slidesPerView: "auto",
        spaceBetween: 0,
        loop: false,
        navigation: {
            nextEl: ".included-accessories__control--next",
            prevEl: ".included-accessories__control--prev",
        },
    });

    $('.included-accessories__control--next').on('click', function (e) {
        e.preventDefault();
        swiper.slideTo(swiper.slides.length - 1);
    });

    $('.included-accessories__control--prev').on('click', function (e) {
        e.preventDefault();
        swiper.slideTo(0);
    });

});